import React, { Component } from 'react';
import constants from '../constants'
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import { FacebookLoginButton } from "react-social-login-buttons";
import icon_fondue from "../../img/ic_launcher.png";
import '../Util/Client';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import Fade from '@material-ui/core/Fade';
import LinearProgress from '@material-ui/core/LinearProgress';


class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            list_org: [],
            selectOrg: "",
            loading: false
        };
    }

    authenticate = (response) => {
        // Api call to server so we can validate the token
        // console.log(response)
        this.AuthLogins(response)
    };

    AuthLogins = (response) => {
        let url = '/api-token-social-auth/facebook/'
        let jsonData = { 'access_token': response.accessToken }
        let headers = { headers: { 'content-type': 'application/json' } }

        axios.post(url, jsonData, headers)
            .then(res => {
                localStorage.setItem('picture', response.picture.data.url)
                localStorage.setItem('name', response.name);
                localStorage.setItem('id', res.data.id);
                localStorage.setItem('token', res.data.token);
                return res
            }).then(res => {
                // console.log(this.props.history)
                if (this.state.selectOrg != '')
                    this.joinGroupOrg(res.data.token)
                else
                    this.props.history.push('/')
            }).catch(error => {
                // this.setState({ loading: false, });
                alert('ไม่สามารถติดต่อข้อมูลได้ !!')
            });
    };

    joinGroupOrg = (token) => {
        this.setState({ loading: true })
        let url = `/fondue-org/${this.state.selectOrg}/join/`
        let headers = {
            headers: {
                'content-type': 'application/json'
                , 'Authorization': `Bearer ${token}`
            }
        }
        axios.post(url, {}, headers)
            .then(res => {
                this.setState({ loading: false })
                this.props.history.push('/')
            }).catch(error => {
                // this.setState({ loading: false, });
                alert('ไม่สามารถติดต่อข้อมูลได้ !!')
                this.setState({ loading: false })
            });
    }

    onChangeCheckOrgRegis = (data) => event => {
        if (this.state.selectOrg != `${data.id}`)
            this.setState({ selectOrg: `${data.id}` });
        else
            this.setState({ selectOrg: '' });
    };

    componentDidMount() {
        document.body.style = 'background: white;';
        axios.get('/fondue-org/list/?id=145,154')
            .then(res => {
                this.setState({ 'list_org': res.data })
            }).catch(error => {
                // this.setState({ loading: false, });
                alert('ไม่สามารถติดต่อข้อมูลได้ !!')
            });
    }

    render() {
        return (
            <div style={{ height: '10em' }}>
                <div style={{
                    margin: 0,
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)'
                }} align={'center'}>
                    <img href="#" src={icon_fondue} style={{ width: 120, height: 120 }} />
                    <h1>Traffy Fondue</h1>
                    <p style={{ color: '#6c757d', fontSize: '1.25rem' }}>แอปพลิเคชั่นแจ้งและติดตามปัญหา</p>
                    <div style={{ width: '90%' }}>
                        <FacebookLogin
                            appId={constants.FACEBOOK_ID}
                            isMobile={true}
                            disableMobileRedirect={true}
                            autoLoad={false}
                            fields="name,email,picture"
                            callback={this.authenticate}
                            render={renderProps => (
                                <FacebookLoginButton onClick={renderProps.onClick}>
                                    Login with Facebook
                                </FacebookLoginButton>
                            )} />
                    </div>
                    <div>
                        <Fade
                            in={this.state.loading}
                            unmountOnExit>
                            <LinearProgress color="primary" />
                        </Fade>
                    </div>
                    <div>
                        <div style={{ margin: '25px' }}>สมัครสมาชิกหน่วยงาน</div>
                        <Paper style={{ maxHeight: 200, overflow: 'auto' }}>
                            <List dense>
                                {this.state.list_org.map(value => (
                                    <ListItem key={value.id} button onClick={this.onChangeCheckOrgRegis(value)} >
                                        <Avatar alt="picture organization" src={`${value.photo}`} />
                                        <ListItemText primary={`${value.name}`} />
                                        <ListItemSecondaryAction>
                                            <Checkbox
                                                color="primary"
                                                onChange={this.onChangeCheckOrgRegis(value)}
                                                checked={this.state.selectOrg == `${value.id}`}
                                                value={`${value.id}`}
                                            />
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                ))}
                            </List>
                        </Paper>
                    </div>

                    {/* ---------------- */}
                </div>
            </div>
        );
    }
}
export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js